
  import { nameRoutes, mdiSvg } from '@/core';
import {Component, Vue} from 'vue-property-decorator';

  @Component
  export default class NoBookingPopUp extends Vue {

    firstname = window.localStorage.getItem('firstname');

    lastname = window.localStorage.getItem('lastname')

    routes = nameRoutes;

    svgLibrairy = mdiSvg;


  }
